// TODO: use GonConfigIncludable to pass tiles and supported locales from server to client

import { tiles } from '../../../config/settings/map.yml'
import { supported as supportedLocales } from '../../../config/settings/locale.yml'

const placesApiKey = 'AIzaSyBIfV0EMXrTDjrvD92QX5bBiyFmBbT-W8E'

export { tiles, supportedLocales, placesApiKey }
export default { tiles, supportedLocales, placesApiKey }
